import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWorkspaceUsersByWorkspaceIdQueryVariables = Types.Exact<{
  workspaceIds?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type GetWorkspaceUsersByWorkspaceIdQuery = { __typename?: 'query_root', workspaceUsers: Array<{ __typename?: 'workspaceUsers', user: { __typename?: 'users', id: string, firstName: string, lastName: string, fullName?: string | null, title?: string | null, email: string, phone?: string | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null, isContributor?: boolean | null, isEnabled?: boolean | null, updatedAt?: any | null, specialtyId?: any | null, roleId?: number | null, workspaceLocationId?: number | null, userSpecialty?: { __typename?: 'specialties', id: any, name: string, parentId?: any | null, specialtyGroup?: { __typename?: 'specialties', id: any, name: string } | null } | null, role?: { __typename?: 'roles', id: number, name: string, parentId?: number | null, roleGroup?: { __typename?: 'roles', id: number, name: string } | null } | null, workspaceLocation?: { __typename?: 'workspaceLocations', name: string, abbreviation?: string | null, id: number, city?: string | null, state?: string | null } | null, workspaces: Array<{ __typename?: 'workspaceUsers', workspaceId: number, workspace: { __typename?: 'workspaces', id: number, name: string, locations: Array<{ __typename?: 'workspaceLocations', id: number, name: string, workspaceId: number, abbreviation?: string | null }> } }> } }> };


export const GetWorkspaceUsersByWorkspaceIdDocument = gql`
    query getWorkspaceUsersByWorkspaceId($workspaceIds: [Int!]) {
  workspaceUsers(where: {workspaceId: {_in: $workspaceIds}}) {
    user {
      id
      firstName
      lastName
      fullName
      title
      email
      phone
      mentorEnabled
      menteeEnabled
      isContributor
      isEnabled
      updatedAt
      specialtyId
      userSpecialty {
        id
        name
        parentId
        specialtyGroup {
          id
          name
        }
      }
      roleId
      role {
        id
        name
        parentId
        roleGroup {
          id
          name
        }
      }
      workspaceLocationId
      workspaceLocation {
        name
        abbreviation
        id
        city
        state
      }
      workspaces(where: {workspace: {active: {_eq: true}}}) {
        workspaceId
        workspace {
          id
          name
          locations(where: {active: {_eq: true}}) {
            id
            name
            workspaceId
            abbreviation
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetWorkspaceUsersByWorkspaceIdQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUsersByWorkspaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUsersByWorkspaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUsersByWorkspaceIdQuery({
 *   variables: {
 *      workspaceIds: // value for 'workspaceIds'
 *   },
 * });
 */
export function useGetWorkspaceUsersByWorkspaceIdQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceUsersByWorkspaceIdQuery, GetWorkspaceUsersByWorkspaceIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceUsersByWorkspaceIdQuery, GetWorkspaceUsersByWorkspaceIdQueryVariables>(GetWorkspaceUsersByWorkspaceIdDocument, options);
      }
export function useGetWorkspaceUsersByWorkspaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceUsersByWorkspaceIdQuery, GetWorkspaceUsersByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceUsersByWorkspaceIdQuery, GetWorkspaceUsersByWorkspaceIdQueryVariables>(GetWorkspaceUsersByWorkspaceIdDocument, options);
        }
export function useGetWorkspaceUsersByWorkspaceIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceUsersByWorkspaceIdQuery, GetWorkspaceUsersByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceUsersByWorkspaceIdQuery, GetWorkspaceUsersByWorkspaceIdQueryVariables>(GetWorkspaceUsersByWorkspaceIdDocument, options);
        }
export type GetWorkspaceUsersByWorkspaceIdQueryHookResult = ReturnType<typeof useGetWorkspaceUsersByWorkspaceIdQuery>;
export type GetWorkspaceUsersByWorkspaceIdLazyQueryHookResult = ReturnType<typeof useGetWorkspaceUsersByWorkspaceIdLazyQuery>;
export type GetWorkspaceUsersByWorkspaceIdSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceUsersByWorkspaceIdSuspenseQuery>;
export type GetWorkspaceUsersByWorkspaceIdQueryResult = Apollo.QueryResult<GetWorkspaceUsersByWorkspaceIdQuery, GetWorkspaceUsersByWorkspaceIdQueryVariables>;